import React, { useState , useEffect} from "react";
import Header from "../Section/Header";
import Footer from "../Section/Footer";
import { FileCheck2 } from "lucide-react";
import {
  terms_link,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import Loader from "../Section/Loader";

export default function PrivacyPolicy() {
   const [privacy, setPrivacy] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const master_data_get = async () => {
     setIsLoading(true);
     await server_post_data(terms_link, null)
       .then((Response) => {
         setIsLoading(false);
         setPrivacy(JSON.parse(Response));
       })
       .catch((error) => {
         setIsLoading(false);
         console.log(error);
       });
   };
   useEffect(() => {
     master_data_get();
   }, []);
  return (
    <div>
      <Header />
      {isLoading && <Loader />}
      <div className="min-h-screen bg-gradient-to-br from-[#1e1e2f] via-[#311744] to-[#1e1e2f] animate-gradient-flow py-12 px-4">
        <div className="max-w-5xl mx-auto text-white">
          <div className="text-center mb-12">
            
            <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4 flex justify-center items-center gap-3">
              <FileCheck2 className="w-9 h-9 text-[#d77cdc]" /> Terms &
              Conditions
            </h2>
            <p className="text-lg mt-2 text-gray-300">
              Please read these terms carefully before using our services.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-lg p-6 rounded-2xl border border-purple-600/30  transition duration-300 ease-in-out first:text-base leading-relaxed text-purple-100 space-y-4">
            {isLoading ? (
              <p className="text-center text-purple-300">Loading...</p>
            ) : (
              <div
                className="fade-in transition-opacity duration-500"
                dangerouslySetInnerHTML={{
                  __html: `<div class="text-purple-200">${privacy}</div>`,
                }}
              />
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
